// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { RadioGroup, Radio } from 'informed';

import {
  addCovidTest,
  deleteCovidTest,
  updateCovidTest,
} from '../../../actions/testingActions';

import DateText from '../../DateText.jsx';
import ValidateText from '../../ValidateText.jsx';
import Table from '../../Table.jsx';
import { Button } from '../../Buttons.jsx';

type Props = {
  covidTests: Object[],
  activePatientId: string,
  addCovidTest: Function,
  deleteCovidTest: Function,
  updateCovidTest: Function,
}

class CovidTestsComponent extends Component<Props> {
  /* eslint-disable no-param-reassign */
  transformDates(formValues) {
    formValues.date = moment(formValues.date, 'DD-MM-YYYY').toISOString();
  }

  handleDeleteRow = (id: string) => {
    this.props.deleteCovidTest(this.props.activePatientId, id);
  }

  handleSaveRow = (id: string, formData: Object) => {
    this.transformDates(formData.values);
    this.props.updateCovidTest(this.props.activePatientId, {
      testId: id,
      ...formData.values,
    });
  }

  handleSaveNewRow = (formData: Object) => {
    this.transformDates(formData.values);
    this.props.addCovidTest(this.props.activePatientId, formData.values);
  }

  render() {
    let { covidTests } = this.props;
    covidTests = covidTests.map((item, index) => ({ testNum: covidTests.length - index, ...item }));

    const columns = [
      {
        Header: '',
        id: 'index',
        cell: item => `Test #${item.testNum ? item.testNum : ''}`,
        width: 80,
      },
      {
        Header: 'Date',
        id: 'date',
        cell: item => (item.date ? moment(item.date).format() : '--'),
        editCell: item => <DateText field='date' item={item} />,
      },
      {
        Header: 'Type',
        id: 'type',
        editCell: item => (
          <RadioGroup field='type' initialValue={item.type}>
            <Radio value={'Antigen'} />Antigen
            <br />
            <Radio value={'Antibody (IgG)'} />Antibody (IgG)
            <br />
            <Radio value={'Antibody (IgM)'} />Antibody (IgM)
            <br />
            <Radio value={'PCR'} />PCR
          </RadioGroup>
        ),
      },
      {
        Header: 'Result',
        id: 'positive',
        editCell: item => (
          <RadioGroup field='positive' initialValue={item.positive}>
            <Radio value={'Positive'} />Positive
            <br />
            <Radio value={'Negative'} />Negative
            <br />
            <Radio value={'Unknown'} />Unknown
          </RadioGroup>
        ),
      },
      {
        Header: 'Link',
        id: 'link',
        cell: (item) => {
          if (!item.link) {
            return '--';
          }
          let { link } = item;
          if (link.indexOf('http') === -1) {
            link = `http://${link}`;
          }
          return <a target='_blank' rel='noopener noreferrer' href={link}><Button>Open Link</Button></a>;
        },
        editCell: item => <ValidateText
          field='link'
          initialValue={item.link}
          placeholder='e.g. Google Drive link'
          regex={/^(https?:\/\/.*)?$/}
          errorText='Improper URL, please use http://...'
        />,
        width: 150,
      },
    ];

    return (
      <Table
        columns={columns}
        data={covidTests}
        handleDeleteRow={this.handleDeleteRow}
        handleSaveRow={this.handleSaveRow}
        handleSaveNewRow={this.handleSaveNewRow}
      />
    );
  }
}

const mapStateToProps = state => ({
  covidTests: state.patient.data.testing.covidTests,
  activePatientId: state.patient.data.activePatientId,
});

const mapDispatchToProps = dispatch => ({
  addCovidTest:
    (patientId, covidTest) => dispatch(addCovidTest(patientId, covidTest)),
  deleteCovidTest:
    (patientId, covidTestId) => dispatch(deleteCovidTest(patientId, covidTestId)),
  updateCovidTest:
    (patientId, covidTest) => dispatch(updateCovidTest(patientId, covidTest)),
});

const CovidTests = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CovidTestsComponent);

export default CovidTests;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/testing/CovidTests.jsx